// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g3Mm","rootMobile":"styles_rootMobile__3VE45"};